import {
  CHAT_DELIVERY_STATE,
  findMatchingOptimisticClientId,
} from "./chatOptimisticMessages";

export function isInboxEventForOpenChat(payload, openChat) {
  if (String(payload?.event || "").trim().toLowerCase() !== "inbox.message.created") {
    return false;
  }

  const incomingChat = payload?.chat || {};
  const incomingType = String(incomingChat?.type || "").trim().toLowerCase();
  const openType = String(openChat?.type || "").trim().toLowerCase();

  if (openType === "event") {
    return (
      incomingType === "event" &&
      Number(incomingChat?.event_id || 0) > 0 &&
      Number(incomingChat.event_id) === Number(openChat?.eventId || 0)
    );
  }

  const normalizedOpenType = openType === "group" ? "community" : openType;
  return (
    incomingType === normalizedOpenType &&
    Number(incomingChat?.id || 0) > 0 &&
    Number(incomingChat.id) === Number(openChat?.chatId || 0)
  );
}

export function mergeLatestChatPage(existingItems, latestItems) {
  const existing = Array.isArray(existingItems) ? existingItems : [];
  const latest = Array.isArray(latestItems) ? latestItems : [];
  if (!latest.length) return existing;
  if (!existing.length) return latest;

  // A recovery fetch can win the race against the send response/websocket.
  // Reconcile its server copy with the pending local echo before replacing the
  // latest window, otherwise both bubbles are visible until the POST settles.
  const matchedClientIds = new Set();
  const reconciledLatest = latest.map((serverItem) => {
    const clientId = findMatchingOptimisticClientId(existing, serverItem);
    if (!clientId || matchedClientIds.has(clientId)) return serverItem;
    matchedClientIds.add(clientId);
    const optimisticItem = existing.find(
      (item) => String(item?.client_id || "") === String(clientId)
    );
    return {
      ...optimisticItem,
      ...serverItem,
      client_id: clientId,
      local_echo: true,
      delivery_status: CHAT_DELIVERY_STATE.SENT,
    };
  });

  const latestIds = reconciledLatest
    .map((item) => Number(item?.id || 0))
    .filter((id) => id > 0);
  if (!latestIds.length) return existing;

  const firstLatestId = Math.min(...latestIds);
  const lastLatestId = Math.max(...latestIds);
  const outsideLatestWindow = existing.filter((item) => {
    if (matchedClientIds.has(item?.client_id)) return false;
    const id = Number(item?.id || 0);
    return id <= 0 || id < firstLatestId || id > lastLatestId;
  });

  return [...outsideLatestWindow, ...reconciledLatest].sort((left, right) => {
    const leftId = Number(left?.id || 0);
    const rightId = Number(right?.id || 0);
    if (leftId <= 0 || rightId <= 0) return 0;
    return leftId - rightId;
  });
}
